var exports = {
  "jD": "xdbfd91f1--8766b5--breadcrumbs",
  "nf": "xdbfd91f1--8766b5--link",
  "sv": "xdbfd91f1--8766b5--link-light",
  "JQ": "xdbfd91f1--8766b5--link_wrapper",
};

module.exports = exports;
